import styled from 'styled-components';

const StyledContainer = styled.div`
	position: relative;
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	padding: 12px 10px;
	gap: 10px;
	font-family: 'GT Walsheim Pro';
	font-size: 14px;
	color: #ffffff;

	&:nth-child(2n) {
		background-color: rgba(50, 50, 50, 0.75);
	}
`;

export { StyledContainer as ContentRowContainer };
